export const CabinetColumn = {
  flow: 'y',
  minWidth: '220px',
  width: '220px',
  background: 'inkMid',
  round: 'A',
  border: '1px solid inkBorder',
  overflow: 'hidden',
  flexShrink: '0',

  Header: {
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    align: 'center center',
    background: 'inkMid',
    borderBottom: '1px solid inkBorder',

    CabinetName: {
      text: (el, s) => s.cabinetName || 'Cabinet 1',
      fontSize: 'Z',
      fontWeight: '700',
      color: 'inkText'
    },

    StatusBadge: {
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'C',
      text: (el, s) => {
        const st = s.cabinetStatus
        if (st === 'in-use') return '{{ inUse | polyglot }}'
        if (st === 'cleaning') return '{{ cleaning | polyglot }}'
        if (st === 'maintenance') return '{{ maintenance | polyglot }}'
        return '{{ available | polyglot }}'
      },
      background: (el, s) => {
        const st = s.cabinetStatus
        if (st === 'in-use') return 'blue.15'
        if (st === 'cleaning') return 'amber.15'
        if (st === 'maintenance') return 'red.15'
        return 'teal.15'
      },
      color: (el, s) => {
        const st = s.cabinetStatus
        if (st === 'in-use') return 'blue'
        if (st === 'cleaning') return 'amber'
        if (st === 'maintenance') return 'red'
        return 'teal'
      }
    }
  },

  Slots: {
    flow: 'y',
    gap: 'Y',
    padding: 'Z',
    overflow: 'auto',
    flex: '1',
    childExtends: 'CabinetSlot'
  }
}
